import MetaFilters from '@/types/components/MansionNavigation/MetaFilters';

export default function filterEntries(filters: MetaFilters, excludedKeys: string[] = []) {
  return Object.entries(filters)
    .filter(([key, value]) => {
      // 除外キー配列に含まれるkeyをフィルター条件に追加
      if (excludedKeys.includes(key)) {
        return false;
      }

      // 特定の条件を満たさない場合はフィルターから除外
      if (
        value === false ||
        value === null ||
        value === undefined ||
        value === 0 ||
        value === 45 ||
        key === 'prefecture_id' ||
        key === 'type_navigation' ||
        (key === 'below_limit_station_walk_distance' && value === 22) ||
        (Array.isArray(value) && value.length === 0)
      ) {
        return false;
      }

      // keyがcity_idまたはstation_idの場合、中身の配列が2つ以上ある場合のみ通過
      if ((key === 'city_id' || key === 'station_id') && Array.isArray(value) && value.length < 2) {
        return false;
      }

      return true;
    })
    .map(([key, value]) => {
      // 配列の場合は値をカンマ区切りにして返す
      if (Array.isArray(value)) {
        return `${key}=${value.join(',')}`;
      }
      return `${key}=${value}`;
    })
    .join('&');
}

export function filterApiEntries(filters: MetaFilters, excludedKeys: string[] = []) {
  return Object.entries(filters)
    .filter(([key, value]) => {
      // 除外キー配列に含まれるkeyをフィルター条件に追加
      if (excludedKeys.includes(key)) {
        return false;
      }

      // 条件にマッチしない場合はフィルターから除外
      return (
        value !== false &&
        value !== null &&
        value !== undefined &&
        value !== 0 &&
        value !== 45 &&
        key !== 'type_navigation' &&
        !(key === 'below_limit_station_walk_distance' && value === 22) &&
        !(Array.isArray(value) && value.length === 0)
      );
    })
    .map(([key, value]) => {
      // 配列の場合は値をカンマ区切りにして返す
      if (Array.isArray(value)) {
        return `${key}=${value.join(',')}`;
      }
      return `${key}=${value}`;
    })
    .join('&');
}
